<template>
  <HeroBlock
    variant="compact"
    :eyebrow="eyebrow"
    :heading="heading"
    :lead="lead"
    :primary-cta="primaryCta"
    :secondary-cta="secondaryCta"
    data-testid="subpage-hero"
    @secondary-action="emit('click-hero-button', $event)"
  />
</template>

<script setup lang="ts">
/**
 * Компактный hero для подстраниц (/brief, /calculator, /privacy).
 * Тонкая обёртка над HeroBlock(variant='compact') из Gen 5 —
 * фиксирует отступы и обязательность `heading`.
 */
import HeroBlock, { type HeroCta } from '@/components/domain/HeroBlock.vue';
import { Cta } from '@/types/types';

interface Props {
  eyebrow?: string;
  heading: string;
  lead?: string;
  primaryCta?: HeroCta | null;
  secondaryCta?: HeroCta | null;
}

withDefaults(defineProps<Props>(), {
  eyebrow: '',
  lead: '',
  primaryCta: null,
  secondaryCta: null,
});

const emit = defineEmits<{
  (e: 'click-hero-button', action: Cta): void;
}>();
</script>
